import * as React from 'react';
import { styled } from '@mui/material/styles';
import EditRoadIcon from '@mui/icons-material/EditRoad';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import AcordionHistorial from '../../funtComponents/ConfigFunctions/acordionHistorial';
import { View, TitleTopBar } from '../ConfigFunctions/configElements'

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

export default function ConfigPage() {
  return (

    <View style={Container}>
      <View style={ContainerTopBar}>
        <EditRoadIcon style={IconTopBar} />
        <TitleTopBar style={TitleTopBarStyle}>
          Configuración
        </TitleTopBar>
      </View>
      <View style={BodyTopBar}>
        <Box sx={BodyWrapper}>
          <Grid container spacing={2} columns={10}>
            <Grid item xs={10}>
              <Item>
                <AcordionHistorial />
              </Item>
            </Grid>
           {/*  <Grid item xs={10}>
              <Item>
                <Acordion />
              </Item>
            </Grid> */}
          </Grid>
        </Box>
      </View>
    </View >
  );
}

const Container = {
  height: '100%',
  display: "flex",
  width: '100%',
  backgroundColor: "#f6f6f6",
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}

const ContainerTopBar = { 
  flexDirection: 'row',
  width: '100%', 
  display: 'flex', 
  alignItems: 'center', 
  justifyContent: 'flex-start' 
}

const IconTopBar = { 
  marginLeft: 10, 
  marginBottom: 10, 
  color: 'rgba(229, 29, 29, 0.7)' 
}

const TitleTopBarStyle = { 
  fontSize: 15, 
  color: 'rgba(229, 29, 29, 0.7)', 
  alignSelf: 'flex-start', 
  marginLeft: 15, 
  marginBottom: 10 
}

const BodyTopBar = {
  height: 'auto',
  display: "flex",
  width: '100%',
  backgroundColor: 'rgba(238, 238, 238, 0.9)',
  marginTop: 10,
  borderTopLeftRadius: 20,
  borderTopRightRadius: 20,
  padding: 10,
  alignItems: "center",
  justifyContent: "center",
  flexDirection: "column",
}

const BodyWrapper = { 
  flexGrow: 1, 
  width: '100%', 
  height: '100%', 
}